export default __webpack_public_path__ + "static/media/down-arrow.607f15f1.svg";